import {css} from 'lit'; export default css`sds-form-control{font-size:1.4rem}sds-form-control>sds-checkbox:not([slot=checkbox-horizontal]){display:flex;margin-top:8px}sds-form-control sds-radio-group{margin-top:4px}`;
    